// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { gql, graphql } from 'react-apollo';

import Home from '~/components/content/Home';

const HomeWithData = graphql(
    gql`
    query($latestSort: String, $topSort: String, $state: String) {
        latestReviews: reviews(sort: $latestSort, state: $state) {
            id,
            name,
            slug,
            version,
            publishedAt,
            content {
                brief {
                    md
                }
            }
            author {
                name,
                slug
            },
            platform {
                name
            },
            game {
                name,
                releaseDates {
                    jp,
                    us,
                    eu
                },
                thumbnail {
                    secure_url
                },
                image {
                    secure_url
                },
                developer {
                    name
                }
            }
        },
        topReviews: reviews(sort: $topSort, state: $state) {
            id,
            name,
            slug,
            version,
            publishedAt,
            content {
                brief {
                    md
                }
            }
            author {
                name,
                slug
            },
            game {
                name,
                releaseDates {
                    jp,
                    us,
                    eu
                },
                thumbnail {
                    secure_url
                },
                image {
                    secure_url
                },
                developer {
                    name
                }
            },
            platform {
                name
            },
            objectiveScore {
                score
            }
        }
    }`,
    {
        options: {
            variables: {
                // TODO: make this work /object
                latestSort: '-publishedAt',
                topSort: '-objectiveScore.score',
                state: 'published',
            },
        },
        props: ({ data: { latestReviews, topReviews }, ownProps }) => ({
            ...ownProps,
            latestReviews,
            topReviews,
        }),
    }
)(Home);

@observer
export default class HomeContainer extends React.Component {
    render() {
        return <HomeWithData />;
    }
}



// WEBPACK FOOTER //
// ./src/components/content/HomeContainer.js